/**
 * Logs an error message and error object to the console
 * @param {string} message The message to log
 * @param {Error} error The error to log
 * @returns {void}
 * @example
 * logError('Error handling PDF citation message:', error);
 * @example
 * logWarning('Attempted to set active citation on unmounted component');
 */

const logError = (...data: Parameters<typeof console.error>) => {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.error(...data);
  }
  // Additional logic for logging errors in production can be added here
};

const logWarning = (...data: Parameters<typeof console.warn>) => {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.warn(...data);
  }
  // Additional logic for logging warnings in production can be added here
};

export { logError, logWarning };
